<template>
    <v-navigation-drawer app
        right
        :width="meeting.sidebar_width"
        class="py-4 px-4"
        v-model="meeting.show_nav_drawer"
        v-if="meeting.is_connected"
    >
        <div class="rounded-pill grey align-justify">
            <v-btn v-if="meeting.participants_chat_switch == 'participants'" class="font-weight-bold" rounded small color="primary" width="50%">Participants</v-btn>
            <v-btn v-if="meeting.participants_chat_switch == 'participants'" class="font-weight-medium" rounded small text width="50%" @click="meeting.participants_chat_switch = 'chat'">Chat</v-btn>
            <v-btn v-if="['chat', null].includes(meeting.participants_chat_switch)" class="font-weight-medium" rounded small text width="50%" @click="meeting.participants_chat_switch = 'participants'">Participants</v-btn>
            <v-btn v-if="['chat', null].includes(meeting.participants_chat_switch)" class="font-weight-bold" rounded small color="primary" width="50%">Chat</v-btn>
        </div>


        <!-- PARTICIPANTS -->
        <div v-if="meeting.local_peer && meeting.participants_chat_switch == 'participants'">
            <v-list subheader dense class="mt-4">
                <v-subheader>Hosts</v-subheader>
                <template v-for="peer in meeting.peers.filter(peer => peer.roleName == 'host' || (peer.roleName == 'coach' && meeting.local_peer.roleName != 'guest'))">
                    <meeting-participant-list-item :peer="peer" :local_peer="meeting.local_peer" :key="peer.id"></meeting-participant-list-item>
                </template>
            </v-list>
            
            <meeting-lobby-guests :key="meeting.refresh_lobby" />

            <v-divider></v-divider>
                
            <v-list subheader dense>
                <v-subheader>
                    <v-row>
                        <v-col class="pt-3">Guests</v-col>
                        <v-col class="text-right">
                            <v-btn ripple x-small v-if="['host', 'coach'].includes(meeting.local_peer.roleName)" @click="meeting.muteAllGuests()">
                                <v-icon x-small>mdi-microphone</v-icon>
                                Mute All
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-subheader>

                <template v-for="peer in meeting.peers.filter(peer => peer.roleName == 'guest' || (peer.roleName == 'waiting-room' && meeting.local_peer.roleName != 'guest'))">
                    <meeting-participant-list-item :peer="peer" :local_peer="meeting.local_peer" :key="peer.id"></meeting-participant-list-item>
                </template>

                <!-- <v-list-item v-for="peer in meeting.peers.filter(peer => peer.roleName == 'guest')" :key="peer.id">
                    <v-list-item-avatar color="secondary">
                        <v-icon dark>mdi-account-circle</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="peer.name != '' ? peer.name : 'Anonymous'"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon class="pt-2">
                        <v-btn icon @click="meeting.enablePeerAudio(peer, !meeting.peer_audio_enabled[peer.id])" x-small>
                            <v-icon v-if="!meeting.peer_audio_enabled[peer.id]">mdi-microphone-off</v-icon>
                            <v-icon v-else>mdi-microphone</v-icon>
                        </v-btn>
                        <v-btn icon @click="meeting.enablePeerVideo(peer, !meeting.peer_video_enabled[peer.id])" x-small>
                            <v-icon v-if="!meeting.peer_video_enabled[peer.id]">mdi-video-off</v-icon>
                            <v-icon v-else>mdi-video</v-icon>
                        </v-btn>
                        <meeting-participant-menu :peer="peer" v-if="meeting.permissions.changeRole"></meeting-participant-menu>
                    </v-list-item-icon>
                </v-list-item> -->
            </v-list>
        </div>


        <!-- CHAT -->
        <div v-else-if="meeting.local_peer">
            <v-card class="rounded-lg my-2" outlined>
                <v-card-subtitle>Guest Chat</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="messages-half-height" style="overflow:auto;" ref="guest_messages">
                    <div v-for="message in meeting.messages.filter(message => showGuestMessage(message))" :key="message.id" class="my-2">
                        <div class="text-caption grey--text my-0">{{message.senderName}}</div>
                        <div v-html="formatBody(message.message)" class="white--text"></div>
                    </div>
                    <!-- <div v-for="message in meeting.messages.filter(message => showMessage(message))" :key="message.id">{{message.message}}</div> -->
                </v-card-text>
                <v-card-actions v-if="['host', 'guest'].includes(meeting.local_peer.roleName)">
                    <v-text-field dense hide-details v-model="message_to_guests" outlined label="Message to Guests" @keyup="guestsMessageKeyUp">
                        <template v-slot:append>
                            <v-btn @click="sendGuestsMessage" class="send-btn2" x-small text>
                                <v-icon color="secondary">mdi-send-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card-actions>
            </v-card>

            <v-card outlined class="rounded-lg my-2" v-if="['host', 'coach', 'qa'].includes(meeting.local_peer.roleName)">
                <v-card-subtitle>Host/Coach Chat</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="messages-half-height" style="overflow:auto;" ref="internal_messages">
                    <div v-for="message in meeting.messages.filter(message => showInternalMessage(message))" :key="message.id" class="my-2">
                        <div class="text-caption grey--text my-0">{{message.senderName}}</div>
                        <div v-html="formatBody(message.message)" class="white--text"></div>
                    </div>
                    <!-- <div v-for="message in meeting.messages.filter(message => !showMessage(message))" :key="message.id">{{message.message}}</div> -->
                </v-card-text>
                <v-card-actions v-if="['host', 'coach'].includes(meeting.local_peer.roleName)">
                    <v-text-field dense hide-details v-model="message_to_coaches" outlined label="Message to Coaches" @keyup="coachesMessageKeyUp">
                        <template v-slot:append>
                            <v-btn @click="sendCoachesMessage" class="send-btn2" x-small text>
                                <v-icon color="secondary">mdi-send-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card-actions>
            </v-card>
        </div>
        <template v-slot:append>
            <v-row>
                <v-col>
                    <v-btn v-if="meeting.local_peer.roleName == 'host'" :dark="false" :class="meeting.coach_hand_raised ? 'black--text' : ''" small :outlined="meeting.coach_hand_raised == false" color="yellow" @click="meeting.coach_hand_raised = !meeting.coach_hand_raised">
                        <v-icon small class="mr-2">mdi-hand-front-right-outline</v-icon>
                        Coach
                    </v-btn>
                </v-col>
                <v-col class="text-right">
                    <v-btn text small @click="meeting.show_nav_drawer = false">
                        Close
                        <v-icon>mdi-arrow-collapse-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>

        <!-- <host-profile v-if="['guest'].includes(meeting.local_peer.roleName)" :settings="app.room.settings"></host-profile> -->
    </v-navigation-drawer>
</template>

<script>
import { useMeetingStore } from "../stores/meeting"
import { useAppStore } from "../stores/app"
import MeetingParticipantMenu from './MeetingParticipantMenu.vue'
import MeetingParticipantListItem from './MeetingParticipantListItem.vue'
import MeetingLobbyGuests from './MeetingLobbyGuests.vue'
import HostProfile from './HostProfile.vue'

export default {
  components: { MeetingParticipantMenu, MeetingParticipantListItem, HostProfile, MeetingLobbyGuests },
	name: 'MmeetingNavigationDrawer',
    created() {
        this.meeting = useMeetingStore()
        this.app = useAppStore()
    },
    data: () => {
        return {
            meeting: null,
            app: null,
            message_to_guests: '',
            message_to_coaches: '',
        }
    },
    methods: {
        showGuestMessage: function(message) {
            return !message.recipientRoles 
                || message.recipientRoles?.length == 0
                || message.recipientRoles?.includes('guest')
        },
        showInternalMessage: function(message) {
            return message.recipientRoles && message.recipientRoles.includes(this.meeting.local_peer.roleName)
        },
        guestsMessageKeyUp: function(e) {
            if(e.key == "Enter" && !e.shiftKey) {
                e.preventDefault()
                this.sendGuestsMessage()
            }
        },
        sendGuestsMessage: function() {
            if(this.message_to_guests == '')
                return
            this.meeting.hmsActions.sendBroadcastMessage(this.message_to_guests);
            this.message_to_guests = ''
        },
        coachesMessageKeyUp: function(e) {
            if(e.key == "Enter" && !e.shiftKey) {
                e.preventDefault()
                this.sendCoachesMessage()
            }
        },
        sendCoachesMessage: async function() {
            if(this.message_to_coaches == '')
                return
            this.meeting.hmsActions.sendGroupMessage(this.message_to_coaches, ['host', 'coach', 'qa']);

            // testing an idea. Use presence to trigger the pulling of messages from inside the admin coaching panel
            // so that coaches can see the coaches/hosts chat live
            // and/or juse the presence channel to raise hand, etc.
            // start off as kindof a one-way communication so coaches can observe and decide whether to jump into a meeting

            //TODO: save messages to server, delete when meeting is over

            // const presenceTrackStatus = await this.meeting.presence_channel.track({
            //     user_id: this.user?.userdata?.ID,
            //     room_id: this.app.room.ID,
            //     role: this.meeting?.local_peer?.roleName,
            //     user_name: window.localStorage.getItem('meeting_display_name') ?? '',
            //     message_to_coaches: this.message_to_coaches
            // })
            // console.log("presenceTrackStatus", presenceTrackStatus)


            this.message_to_coaches = ''

        },
        formatBody: function(body) {
            if(!body)
                return
                
            let matches = body.match(/(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g);
            if(matches) {
                matches.forEach(url => {
                    body = body.replace(url, `<a href="${url}" class="white--text" target="_blank">${url}</a>`)
                })
            }

            
            //line breaks
            body = body.replace(/\n\n/g, '<div class="mb-2"></div>')
            body = body.replace(/\n/g, '<br />')
            
            return body
        },
        scrollToBottom: function() {
            this.$refs.guest_messages.scrollTop = this.$refs.guest_messages.scrollHeight;
            if(this.$refs.internal_messages)
                this.$refs.internal_messages.scrollTop = this.$refs.internal_messages.scrollHeight;
        },
    },
    watch: {
        'meeting.participants_chat_switch': function(newV) {
            if(newV == 'chat')
                this.meeting.new_message_count = 0
        },
        'meeting.messages': function(newV) {
            if(newV.length > 0)
                this.$nextTick(() => this.scrollToBottom())
        },
        'meeting.coach_hand_raised': async function() {
            if(!this.meeting.presence_channel.track)
                return
            const presenceTrackStatus = await this.meeting.presence_channel.track({
                user_id: this.user?.userdata?.ID,
                room_id: this.app.room.ID,
                role: this.meeting?.local_peer?.roleName,
                user_name: window.localStorage.getItem('meeting_display_name') ?? '',
                coach_hand_raised: this.meeting.coach_hand_raised
            })
        }
    }
}
</script>

<style scoped>
.messages-half-height {
    height: calc(50vh - 175px);
}
.send-btn {
     margin-top:-8px;
}
</style>